import {
  PATCH_YADS_RECURRING_SCHEDULE_REQUEST,
  PATCH_YADS_RECURRING_SCHEDULE_SUCCESS,
  PATCH_YADS_RECURRING_SCHEDULE_FAILURE,
  PATCH_YADS_RECURRING_SCHEDULE_RESET,
} from '../../../Constants/actionTypes';

const initial = {
  loading: false,
  result: null,
  error: '',
};

const yadsEditRecurringReducer = (state = initial, action) => {
  switch (action.type) {
    case PATCH_YADS_RECURRING_SCHEDULE_REQUEST:
      return { ...state, loading: true, error: '' };
    case PATCH_YADS_RECURRING_SCHEDULE_SUCCESS:
      return { loading: false, result: action.payload, error: '' };
    case PATCH_YADS_RECURRING_SCHEDULE_FAILURE:
      return { loading: false, result: null, error: action.payload };
    case PATCH_YADS_RECURRING_SCHEDULE_RESET:
      return initial;
    default:
      return state;
  }
};

export default yadsEditRecurringReducer;
